<template>
	<div class="header">
		<div class="headtop">
			<div class="w1200">
				<a class="logo" @click="$goBackNuxt('/')" :class="{ active: active == '' }"><img
						src="../assets/images/loginNew.png" /></a>
				<div class="headtopRight">
					<div class="headtopRightSearch">
						<el-input placeholder="" suffix-icon="el-icon-search" v-model="Keywords"
							@keyup.enter.native="searchFn(Keywords)"></el-input>
						<div class="click" @click="searchFn(Keywords)"></div>
					</div>
					<div class="QRCode" @mouseenter="is_show_code = true" @mouseleave="is_show_code = false"><img
							src="../assets/images/QRCode.png" />
						<div class="code_box_img" v-if="is_show_code">
							<img src="~images/QRCode2.png" alt="" class="img_icon" />
						</div>
					</div>
					<div class="mapIcon">
						<img src="../assets/images/mapIcon.png" />{{ city }}
					</div>
					<div class="login">
						<div class="loginSuccess1" v-if="!loginSuccess" @click="$parent.$refs.loginTan.open()">
							登录
						</div>
						<div class="loginSuccess2" v-else @click="$toUrl('myVolunteer')">
							<img :src="userInfo.headImage ? userInfo.headImage : logo_header" class="personal_avatar"
								:alt="userInfo.nickName" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="head">
			<div class="nav">
				<div class="navLi">
					<a @click="$goBackNuxt('/')" :class="{ active: active == '' }">首页</a>
				</div>
				<div class="navLi" @mouseover="assessment = !assessment" @mouseout="assessment = !assessment">
					<a @click="$goBackNuxt('/assessment')"
						:class="{ active: active == 'assessment' || assessment }">科学测评</a>
					<div class="headNavBottom" v-show="assessment">
						<div class="NavBottom_li"
							@click="$goBackNuxt('/assessment/details', { id: '37f5451f24004db0bd19479c5c2daac6' }, 2)">
							MBTI测试
						</div>
						<div class="NavBottom_li"
							@click="$goBackNuxt('/assessment/details', { id: 'cbd9cbdca1ed42cba32de8df8f8b1c9b' }, 2)">
							霍兰德职业兴趣
						</div>
						<div class="NavBottom_li"
							@click="$goBackNuxt('/assessment/details', { id: 'a4a0d006414648e7ab3404c0592706b5' }, 2)">
							综合能力
						</div>
					</div>
				</div>
				<div class="navLi" @mouseover="subjectGuide = !subjectGuide" @mouseout="subjectGuide = !subjectGuide">
					<a @click="$goBackNuxt('/subject-guide')"
						:class="{ active: active == 'subject-guide' || subjectGuide }">高中选科</a>
					<div class="headNavBottom" v-show="subjectGuide">
						<div class="NavBottom_li " @click="$toUrl('subjectSelectMajor')">由科目选专业
						</div>
						<div class="NavBottom_li" @click="$toUrl('addMajor')">由专业选科目
						</div>
						<div class="NavBottom_li" @click="$toUrl('mySubjectScheme')">我的选科方案
						</div>
					</div>
				</div>
				<div class="navLi" @mouseover="schoolmajor = !schoolmajor" @mouseout="schoolmajor = !schoolmajor">
					<a @click="$goBackNuxt('/schoolmajor')"
						:class="{ active: active == 'schoolmajor' || schoolmajor }">院校专业</a>
					<div class="headNavBottom" v-show="schoolmajor">
						<div class="NavBottom_li" @click="$goBackNuxt('/schoolmajor/schoolList')">查院校
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/schoolmajor/majorList')">查专业
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/schoolmajor/professionalList')">查职业
						</div>
					</div>
				</div>
				<div class="navLi" @mouseover="planguide = !planguide" @mouseout="planguide = !planguide">
					<a @click="$goBackNuxt('/project-guide')"
						:class="{ active: active == 'project-guide' || planguide }">升学规划</a>
					<div class="headNavBottom" v-show="planguide && planList.length">
						<div class="NavBottom_li" style="width:140px" v-for="item, index in planList" :key="index"
							@click="$goBackNuxt('/project-guide/detail',{id:item.jumpUrl},2)">{{ item.title }}
						</div>
					</div>
				</div>
				<div class="navLi">
					<a @click="$windowOpen({ path: `/fill-guide/simulation` })"
						:class="{ active: active == 'simulation' }">志愿填报</a>
				</div>
				<div class="navLi" @mouseover="fillguide = !fillguide" @mouseout="fillguide = !fillguide">
					<a @click="$toUrl('schoolData')" :class="{ active: active == 'fill-guide' || fillguide }">高考工具</a>
					<div class="headNavBottom" v-show="fillguide">
						<div class="NavBottom_li" @click="$toUrl('schoolData')">院校数据查询
						</div>
						<div class="NavBottom_li" @click="$toUrl('majorData')">专业数据查询
						</div>
						<div class="NavBottom_li" @click="$toUrl('admissionPlan')">招生计划查询
						</div>
						<div class="NavBottom_li" @click="$toUrl('targetSchool')">目标院校对比
						</div>
						<div class="NavBottom_li" @click="$toUrl('scoreLevel')">一分一段
						</div>
						<div class="NavBottom_li" @click="$toUrl('BatchLine')">批次线查询
						</div>
						<div class="NavBottom_li" @click="$toUrl('pointsQuery')">出分查询
						</div>
					</div>
				</div>
				<div class="navLi" @mouseover="consult = !consult" @mouseout="consult = !consult">
					<a @click="$goBackNuxt('/consult')" :class="{ active: active == 'consult' || consult }">高考资讯</a>
					<div class="headNavBottom" v-show="consult">
						<div class="NavBottom_li" v-for="(item,index) in navList" :key="index"
							@click="$goBackNuxt('/consult?NewsType=' + item.id)">{{item.name}}
						</div>
					</div>
				</div>
				<div class="navLi" @mouseover="Curriculum = !Curriculum" @mouseout="Curriculum = !Curriculum">
					<a @click="$goBackNuxt('/Curriculum')"
						:class="{ active: active == 'Curriculum' || Curriculum }">专家课程</a>
					<div class="headNavBottom" v-show="Curriculum">
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=200')">高中选科讲解
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=215')">中外合办讲解
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=216')">综合评价解读
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=217')">高中体制规划
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=218')">大学专业解读
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=210')">高考形式解析
						</div>
						<!-- <div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=198')">在线走访校园
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=199')">大学招生宣讲
						</div>
						<div class="NavBottom_li" @click="$goBackNuxt('/Curriculum?Type=201')">学长学姐说专业
						</div> -->
					</div>
				</div>
				<div class="navLi">
					<a @click="buyCard" :class="{ active: active == 'buy-card' }">凌云卡</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import logo_header from "@/assets/images/logo_default.png"
	export default {
		name: "topHeader",
		props: {},
		data() {
			return {
				subjectGuide: false,
				assessment: false,
				schoolmajor: false,
				fillguide: false,
				planguide: false,
				consult: false,
				Curriculum: false,
				active: "home",
				city: "",
				planList: [],

				Keywords: "",
				is_show_code: false,
				loginSuccess: false,
				userInfo: "",
				logo_header,
				navList: [{
						"id": 1931,
						"name": "高考政策",
					},
					{
						"id": 1932,
						"name": "招生资讯",
					},
					{
						"id": 5445,
						"name": "选科指导",
					},
					{
						"id": 5446,
						"name": "志愿填报",
					},
					{
						"id": 1934,
						"name": "院校专业",
					},
					{
						"id": 5447,
						"name": "考试资讯",
					},
					{
						"id": 5448,
						"name": "家长课堂",
					},
					{
						"id": 2261,
						"name": "高考动态",
					}
				],
			};
		},
		created() {
			this.getPageType();
		},
		mounted() {
			if (this.cookie.get("token")) {
				this.loginSuccess = true;
				this.getUserInfo();
				this.$store.state.token = this.cookie.get("token");
			}
			this.getCity();
		},
		watch: {
			// 监听路由变化改变导航选中状态
			$route(to, from) {
				this.active = to.path.split("/")[1];
				if (to.path.split("/")[2] == "simulation" || to.path.split("/")[2] == "simulation-details") {
					this.active = "simulation"
				}
				if (to.path.split("/")[2] == "Intelligence") {
					this.active = "simulation"
				}
				console.log("this.active", to.path);
			},
			"$store.state.city"(newVal, oldVal) {
				//对数据执行操作
				this.getCity();
			},
			"$store.state.loginSuccess"(newVal, oldVal) {
				console.log("对数据执行操作")
				//对数据执行操作
				this.loginSuccess = this.$store.state.loginSuccess;
				this.userInfo = this.$store.state.userInfo;
				this.getUserInfo();
			},
		},
		methods: {
			searchFn(Keywords) {
				this.$goBackNuxt('/search', {
					Keywords: Keywords
				}, 2)
			},
			getPageType() {
				if (sessionStorage.getItem('plan_nav_list')) {
					this.planList = JSON.parse(sessionStorage.getItem('plan_nav_list'))
				} else {
					this.$request({
						api: "plan",
						url: "Page/Info",
						data: {
							pageInfoTypeId: '246d1b6cdeeb49629d3bca9a23c127bc',
						},
					}).then((res1) => {
						let {
							data
						} = res1
						this.planList = data
						sessionStorage.setItem('plan_nav_list', JSON.stringify(data))
					});
				}

			},
			buyCard() {
				this.$toUrl("buyCard");
			},
			getCity() {
				let that = this;
				if (this.cookie.get("token")) {
					this.city = JSON.parse(this.cookie.get("userInfo")).province;
				} else {
					this.$request({
							api: "passport",
							url: "Company/ByIP",
						})
						.then((res) => {
							console.log(res);
							this.city = res.data.lxCompany;
							this.cookie.set("city", res.data.lxCompany)
						})
						.catch((err) => {
							console.log(err, "err");
							return;
						});
				}
			},
			getUserInfo() {
				this.$request({
						api: "plan",
						url: "UserInfo/" + this.userInfo.id,
						method: "get",
					})
					.then((res) => {
						if(res.StatusCode == 401){
							this.cookie.delete("token");
							this.loginSuccess = false;
						}
						res.data.phone = res.data.mobile.replace(
							/^(\d{3})\d{4}(\d{4})$/,
							"$1****$2"
						);
						this.userInfo = res.data;
						let expiration_time = this.cookie.get("loginTime");
						let expiresNum = 1;
						if (expiration_time) {
							expiresNum = 30;
						}
						this.cookie.set("userInfo", JSON.stringify(res.data), {
							expires: expiresNum,
						});
					})
					.catch((err) => {
						if(err.StatusCode == 401){
							this.cookie.delete("token");
							this.loginSuccess = false;
						}
						console.log(err, "err");
						return;
					});
			},
		},
	};
</script>

<style lang="scss" scoped="">
	.header {
		min-width: 1200px;
		white-space: nowrap;
		background: #FFFFFF;
		position: relative;
		z-index: 7;

		.headtop {
			height: 60px;
			background: #D70024;

			>div {
				display: flex;
				justify-content: flex-end;
				align-items: center;

				.logo {
					width: 74px;
					height: 116px;
					position: absolute;
					top: 0;
					left: 0;

					img {
						display: block;
						width: 74px;
						height: 116px;
					}
				}

				.headtopRight {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 420px;
					height: 60px;

					.headtopRightSearch {
						width: 195px;
						height: 42px;
						background: rgba($color: #96000B, $alpha: 0.37);
						border-radius: 21px;
						overflow: hidden;
						margin-right: 26px;
						position: relative;

						:deep(.el-input__inner) {
							background: none;
							border: none;
							color: #FFF;
							font-size: 14px;
						}

						:deep(.el-icon-search:before) {
							font-size: 16px;
							color: #FFF;
						}

						.click {
							width: 42px;
							height: 42px;
							position: absolute;
							top: 0;
							right: 0;
							cursor: pointer;
						}
					}

					.QRCode {
						display: flex;
						align-items: center;
						height: 60px;
						width: 20px;
						position: relative;
						margin-right: 41px;

						>img {
							display: block;
							width: 20px;
							height: 20px;
						}

						.code_box_img {
							position: absolute;
							top: 60px;
							left: -40px;
							width: 100px;
							height: 100px;
							z-index: 99;

							>img {
								display: block;
								width: 100px;
								height: 100px;
							}
						}
					}

					.mapIcon {
						display: flex;
						align-items: center;
						height: 60px;
						position: relative;
						margin-right: 41px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #FFFFFF;
						line-height: 20px;

						>img {
							display: block;
							width: 20px;
							height: 20px;
							margin-right: 6px;
						}
					}

					.login {
						display: flex;
						align-items: center;
						height: 60px;
						position: relative;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 14px;
						color: #FFFFFF;
						line-height: 20px;

						.loginSuccess1 {
							cursor: pointer;
						}

						.loginSuccess2 {
							display: flex;
							align-items: center;
							justify-content: center;
							width: 46px;
							height: 46px;
							border-radius: 23px;
							border: 3px #FFF solid;
							overflow: hidden;
							background: #FFFFFF;
							cursor: pointer;

							img {
								display: block;
								width: 46px;
								height: 46px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}

		.head {
			width: 1200px;
			margin: 0 auto;

			.nav {
				display: flex;
				align-items: center;
				position: relative;
				margin-left: 200px;

				.navLi {
					position: relative;
					margin-right: 30px;
				}

				a {
					width: 100%;
					height: 72px;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 400;
					font-size: 16px;
					color: rgba(0, 0, 0, 0.9);
					line-height: 24px;
					display: flex;
					align-items: center;
					position: relative;
					cursor: pointer;

					&.router-link-exact-active {
						// &::before {
						//   content: "";
						//   width: 30px;
						//   height: 3px;
						//   background: #fff;
						//   position: absolute;
						//   bottom: -13px;
						//   left: 50%;
						//   margin-left: -15px;
						//   border-radius: 2px;
						// }
					}

					&.active,
					&:hover {
						font-weight: bold;
						background: url("../assets/images/navIcon.png") center 50px no-repeat;
						background-size: 9px 13px;
					}
				}
			}

			.headNavBottom {
				width: 158px;
				background: #FFFFFF;
				border-radius: 0px 0px 3px 3px;
				border-top: 3px #D70024 solid;
				position: absolute;
				top: 72px;
				left: 0;
				padding: 25px 8px;

				.NavBottom_li {
					width: 142px;
					height: 34px;
					cursor: pointer;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					line-height: 34px;
					padding-left: 20px;
					border-radius: 3px;

					&:hover {
						width: 142px;
						height: 34px;
						background: rgba($color: #D70024, $alpha: 0.1);
						border-radius: 3px;
					}
				}
			}
		}
	}
</style>
